import moment from 'moment';
import { useSelector } from 'react-redux';

import { FormContainer, FormHeader } from 'pages/OnboardingV2Agent/components';
import classNames from 'classnames';
import { Button } from 'components';
import { Icons } from 'pages/Clarity/Icons';
import { ConfettiBlueIcon, TeamIcon } from './icons';
import { getUserDataSelector } from 'store/selectors/user';

import parentStyles from 'pages/SignupV2/components/PersonalDetails/styles.module.scss';
import styles from './styles.module.scss';

export const MessageV2 = ({ onNext }) => {
  const user = useSelector(getUserDataSelector);

  const trailEndDate =
    user?.Agent?.SubscriptionCustomer?.TrialEndTimestamp || moment().add(1, 'month').toISOString();

  const messageItems = [
    {
      icon: <ConfettiBlueIcon />,
      content: (
        <span>
          <strong>Your implementation fee will be due today.</strong> This is a{' '}
          <strong>one-time, non-refundable fee</strong> that covers your account activation,
          onboarding support, and ongoing optimization.
        </span>
      ),
    },
    {
      icon: <Icons variant="partners" />,
      content: <strong>You&apos;ll then receive your account access immediately.</strong>,
    },
    {
      icon: <Icons variant="clients" />,
      content: (
        <span>
          <strong>Our onboarding team will reach out to you within one business day</strong> to
          provide any necessary support as you integrate Mosaik into your business.
        </span>
      ),
    },
    {
      icon: <TeamIcon />,
      content: (
        <span>
          <strong>
            Your first monthly subscription payment will be billed on{' '}
            {moment(trailEndDate).format('MMMM DD, YYYY')}.&nbsp;
          </strong>
          If you&apos;re eligible for a promotion, our onboarding team will ensure it&apos;s applied
          before then - no action needed on your part.
        </span>
      ),
    },
  ];

  return (
    <FormContainer classname={styles.formContainer}>
      <div className={classNames(parentStyles.formContainer)}>
        <FormHeader
          title="Great! Subscriptions are limited in each market, but we still have availability in yours."
          subTitle="Here's what happens next:"
        />
        <div className={styles.messageContainer}>
          {messageItems.map((item, index) => (
            <div key={index} className={styles.messageWrapper}>
              <div>{item.icon}</div>
              <div className={styles.text}>{item.content}</div>
            </div>
          ))}
        </div>
        <div className={styles.footer}>
          <div className={styles.title}>
            <span>
              If you&apos;d like to <strong>save 20%</strong> through our annual plans, just let our
              onboarding team know after sign-up.
            </span>
          </div>
          <Button className={styles.btn} title="Sounds good!" onClick={onNext} />
        </div>
      </div>
    </FormContainer>
  );
};
